import { useState } from "react";
import { axiosInstance, setSession } from "../../utils";
import eye from "../../assets/svgs/eye.svg";
import eye_slash from "../../assets/svgs/eye_slash.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logIn } from "../../redux/features/authSlice";
import { decodeToken } from "react-jwt";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Login() {
  const [data, setData] = useState({
    username: "",
    password: "",
  });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [errorUsername, setErrorUserName] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);

  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

   const handleShowPassword = () => {
     setShowPassword(prev => !prev);
   }

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  }

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-zA-Z\s]+$/; 
    if (value.match(regex) || value === "") {
      setUsername(value);  
    }
    
  }
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if(!username) {
        setErrorUserName(true);
      } else if(!data.password) {
        setErrorPassword(true);
      } else if(username === "admin") {
         await axiosInstance.post("/api/authenticate-super-admin", {
            username: username,
            password: data.password
          })
          .then(res => {
            toast.success(res.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
                localStorage?.setItem("token", res.data?.data?.id_token);
            const access_token = res.data?.data?.id_token;
            setSession(access_token);
            const decode = decodeToken(access_token);
            
            dispatch(logIn(decode))
           
            navigate("/dashboard");
          })
          .catch(err => {
            toast.error(err.response.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          
          })
       } else {
        await axiosInstance.post("/api/authenticate-admin", {
          username: username,
          password: data.password
        })
        .then(res => {
          toast.success(res.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
              localStorage?.setItem("token", res.data?.data?.id_token);
          const access_token = res.data?.data?.id_token;
          setSession(access_token);
          const decode = decodeToken(access_token);
        
          dispatch(logIn(decode))
          navigate("/dashboard");
        })
        .catch(err => {
          toast.error(err.response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        })
       }
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        });  
    }
  
  }
   
  return <main className="h-screen flex justify-center items-center bg-gradient-to-r from-secondary-gold to-secondary-yellow-600">
    <div className="bg-white  h-[300px] rounded-md p-10 w-[300px] sm:h-[400px] sm:w-[500px] lg:w-[500px] lg:h-[400px]">
      <h1 className="heading-one !text-center !pb-1 lg:!pb-5">Login Form</h1>
      <form className="space-y-2 lg:space-y-4 " onSubmit={handleLoginSubmit}>
        <div>
          <label htmlFor="username" className="block text-sm font-medium font-poppins leading-5 text-secondary-n-200">Username</label>
          <input type="text" name="username" value={username} onChange={handleUsernameChange} placeholder="Enter your Username" className={`w-full h-8 sm:h-12 lg:h-12 rounded-md outline-none border-[1px] ${errorUsername ? "border-primary-red-500" : " border-secondary-n-50"}   text-secondary-n-90 font-normal text-sm pl-4 placeholder:text-secondary-n-90 font-poppins mb-2 placeholder:font-normal placeholder:text-sm placeholder:font-poppins`} />

          {errorUsername ? (<p className="font-poppins text-sm font-medium text-primary-red-500">Please Fill Out Username!</p>) : ("")}
        </div>
        <div className="">

          <label htmlFor="password" className="block text-sm font-medium font-poppins leading-5 text-secondary-n-200">Password</label>
          <div className="relative">
          <input type={`${ showPassword ? "text" : "password"}`} name="password" value={data.password} onChange={handleLoginChange} placeholder="Enter your Password" className={`w-full h-8 sm:h-12 lg:h-12 font-poppins rounded-md outline-none border-[1px] ${errorPassword ? "border-primary-red-500" : "border-secondary-n-50"}  mb-2 text-secondary-n-90 font-normal text-sm pl-4 placeholder:text-secondary-n-90  placeholder:font-poppins placeholder:font-normal placeholder:text-sm`} />
          {errorPassword ? (<p className="font-poppins text-sm font-medium text-primary-red-500">Please Fill Out Password!</p>) : ("")}

          <div className="absolute top-2 sm:top-4 lg:top-4 right-2 sm:right-6 lg:right-6">
            { showPassword ? (
              <img src={eye_slash}  className="text-secondary-n-90" onClick={handleShowPassword} alt="eye_slash icon" />
              ) : (
                <img src={eye} onClick={handleShowPassword} alt="eye icon" />
            ) }
          </div>
          </div>
        </div>
        {/* <p className="font-medium text-sm font-poppins text-secondary-n-90">Forgot password?</p> */}
        <button type="submit" className="w-full h-8 sm:h-10 lg:h-10 bg-primary-yellow-500 rounded-md flex justify-center items-center font-poppins text-white font-medium text-sm outline-none">Login</button>
      </form>
      <ToastContainer />
    </div>
  </main>;
}
